import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { AndExpression } from "../../../Models/Logical/AndExpression";

export class AndExpressionEvaluator implements IExpressionEvaluator<AndExpression> {
  get type(): string {
    return "And";
  }

  // Evaluates values in order and returns the last value (short-circuit AND logic).
  // If the last value is falsy, returns the last evaluated value.
  evaluate(expression: AndExpression, context: IExpressionEvaluatorContext): MaybePromise {
    let result = undefined;
    for (let i = 0; i < expression.Value.length; i++) {
      result = context.Evaluator.evaluate(expression.Value[i], context);

      // If we got a promise, we need to switch to async
      if (result instanceof Promise) {
        return result.then((resolvedResult) => {
          if (!resolvedResult) {
            return resolvedResult;
          }
          // Continue with remaining expressions asynchronously
          return this.evaluateRemainingAsync(expression.Value, i + 1, context);
        });
      }

      // Short-circuit: if falsy, return immediately
      if (!result) {
        return result;
      }
    }
    return result;
  }

  private async evaluateRemainingAsync(values: any[], startIndex: number, context: IExpressionEvaluatorContext): Promise<any> {
    let result = undefined;
    for (let i = startIndex; i < values.length; i++) {
      result = await context.Evaluator.evaluate(values[i], context);
      if (!result) {
        return result;
      }
    }
    return result;
  }
}
